import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Grid,
  Typography,
  Box,
  Button,
} from "@mui/material";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const VendorServiceCards = ({
  vendorDetails,
  HandleBackToViewDetail,
  setSelectedService,
  setFilterByIds,
}) => {
  return (
    <div id="Serviceone">
      <h1 style={{ textAlign: "center" }}>Vendor Services</h1>
      {/* Check if vendorDetails is not null/undefined and has items */}
      {vendorDetails && vendorDetails.length > 0 ? (
        <Grid container className="Serviceone-container" spacing={3}>
          {vendorDetails.map((service, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card className="Serviceone-cards">
              {Array.isArray(service.BannerImage) ? (
  service.BannerImage.map((img, index) => {
    console.log("Image Object (Array Case):", img); // Log each image object
    console.log("Original Path:", img.path);

    const processedPath = img.path
      .replace("/home/ubuntu/new/CEP_BackEnd", "")
      .replace("/home/CEP_BackEnd", "");
    
    const finalImageUrl = `${BASE_URL}${processedPath}`.replace(/([^:])\/\//g, "$1/");

    console.log("Processed Path:", processedPath);
    console.log("Final Image URL:", finalImageUrl);

    return (
      <Card key={index} style={{ width: "100%", padding: "5px" }}>
        <CardMedia
          component="img"
          height="250"
          image={finalImageUrl}
          alt={`Owner Image ${index + 1}`}
          style={{
            borderRadius: "5px",
            objectFit: "cover",
          }}
        />
      </Card>
    );
  })
) : typeof service.BannerImage === "string" && service.BannerImage.length > 0 ? (
  JSON.parse(service.BannerImage).map((img, index) => {
    console.log("Image Object (String Case):", img); // Log each image object
    console.log("Original Path:", img.path);

    const processedPath = img.path
      .replace("/home/ubuntu/new/CEP_BackEnd", "")
      .replace("/home/CEP_BackEnd", "");

    const finalImageUrl = `${BASE_URL}${processedPath}`.replace(/([^:])\/\//g, "$1/");

    console.log("Processed Path:", processedPath);
    console.log("Final Image URL:", finalImageUrl);

    return (
      <Card key={index} style={{ width: "100%", padding: "5px" }}>
        <CardMedia
          component="img"
          height="250"
          image={finalImageUrl}
          alt={`Owner Image ${index + 1}`}
          style={{
            borderRadius: "5px",
            objectFit: "cover",
          }}
        />
      </Card>
    );
  })
) : (
  <Typography variant="body1">No images available</Typography>
)}


                <CardContent>
                  {/* Title */}
                  <Typography variant="h6" gutterBottom>
                    Company Name: {service.companyName || "Service Name"}{" "}
                    {/* Replace with the correct field */}
                  </Typography>

                  {/* Description */}
                  <Typography variant="body2" color="textSecondary">
                    Service Name:{" "}
                    {service.ServiceName || "No description available"}{" "}
                    {/* Replace with the correct field */}
                  </Typography>

                  {/* Additional Details */}
                  <Typography variant="body2" color="textPrimary">
                    Description: {service.ServiceDescription || "N/A"}{" "}
                    {/* Replace with the correct field */}
                  </Typography>
                  <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setSelectedService(service.ServiceName); // Set the service name to the dropdown
                        setFilterByIds(service.id);
                        HandleBackToViewDetail();
                      }}
                    >
                      View Details
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography variant="body2" color="textSecondary">
          No services available.
        </Typography>
      )}
    </div>
  );
};

export default VendorServiceCards;
